import enTranslations from '@app/locales/en.json';
import arTranslations from '@app/locales/ar.json';

// https://github.com/yahoo/react-intl/wiki/Upgrade-Guide#flatten-messages-object
const flattenMessages = ((nestedMessages, prefix = '') => {
  if (nestedMessages === null) {
    return {};
  }
  return Object.keys(nestedMessages).reduce((messages, key) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      Object.assign(messages, { [prefixedKey]: value });
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }

    return messages;
  }, {});
});

export const languages = {
  EN: 'en',
  AR: 'ar',
};

export const messages = {
  [languages.EN]: flattenMessages(enTranslations),
  [languages.AR]: flattenMessages(arTranslations),
};
